import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import './Navbar.css';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [dogOpen, setDogOpen] = useState(false);
  const [trainingOpen, setTrainingOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
    setDogOpen(false);
    setTrainingOpen(false);
  }, [location]);

  const isActive = (path) => location.pathname === path;

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__container container">
        <Link to="/" className="navbar__logo">
          <img src="/images/logo.png" alt="Tails and Tweed" />
        </Link>

        <div className={`navbar__menu ${isOpen ? 'navbar__menu--open' : ''}`}>
          <Link to="/" className={`navbar__link ${isActive('/') ? 'navbar__link--active' : ''}`}>
            Home
          </Link>

          <Link to="/team" className={`navbar__link ${isActive('/team') ? 'navbar__link--active' : ''}`}>
            About
          </Link>

          <div
            className="navbar__dropdown"
            onMouseEnter={() => setDogOpen(true)}
            onMouseLeave={() => setDogOpen(false)}
          >
            <Link to="/services" className={`navbar__link navbar__link--dropdown ${
              ['/services', '/spa-experiences', '/emmipet-dental'].includes(location.pathname)
                ? 'navbar__link--active' : ''
            }`}>
              Dog Grooming <ChevronDown size={14} />
            </Link>
            <div className={`navbar__dropdown-menu ${dogOpen ? 'navbar__dropdown-menu--open' : ''}`}>
              <Link to="/spa-experiences" className="navbar__dropdown-link">Spa Treatments</Link>
              <Link to="/emmipet-dental" className="navbar__dropdown-link">Emmipet Dental Treatment</Link>
            </div>
          </div>

          <Link to="/cat-grooming" className={`navbar__link ${isActive('/cat-grooming') ? 'navbar__link--active' : ''}`}>
            Cat Grooming
          </Link>

          <div
            className="navbar__dropdown"
            onMouseEnter={() => setTrainingOpen(true)}
            onMouseLeave={() => setTrainingOpen(false)}
          >
            <Link to="/training" className={`navbar__link navbar__link--dropdown ${
              isActive('/training') ? 'navbar__link--active' : ''
            }`}>
              Groomer Training <ChevronDown size={14} />
            </Link>
            <div className={`navbar__dropdown-menu ${trainingOpen ? 'navbar__dropdown-menu--open' : ''}`}>
              <Link to="/training" className="navbar__dropdown-link">City &amp; Guild Level 2</Link>
              <Link to="/training" className="navbar__dropdown-link">City &amp; Guild Level 3</Link>
              <Link to="/training" className="navbar__dropdown-link">Combined Level 2 and Level 3</Link>
              <Link to="/training" className="navbar__dropdown-link">Student Finance</Link>
            </div>
          </div>

          <Link to="/contact" className={`navbar__link ${isActive('/contact') ? 'navbar__link--active' : ''}`}>
            Contact
          </Link>

          <a
            href="https://app.toplinedogs.co.uk/public/online-bookings?salon=YWJmZDE4NjAtMWMzZi00NjMyLTkyNTQtMDhkOWI2OGFiZGUx"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-accent navbar__cta"
          >
            Book Grooming
          </a>
        </div>

        <button
          className="navbar__toggle"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
